module.exports = __webpack_public_path__ + "img/f4adfda18ef5cb28193fd0b3a26883c3.svg";